export default __webpack_public_path__ + "static/demonstration-2de9fba981946291b3d34291a7d35af0.svg";